import type { DeviceSummary } from '@aiscoreboard/contracts';

// A Pi polls every 30 seconds. Allow two missed polls plus network jitter.
const ACTIVE_CAMERA_WINDOW_MS = 90_000;

export function isCameraLicenseExpired(device: Pick<DeviceSummary, 'license'> | undefined): boolean {
  return Boolean(device?.license?.enforcementEnabled && device.license.status === 'expired');
}

export function isCameraAvailable(
  device: Pick<DeviceSummary, 'lastSeenAt' | 'license'> | undefined,
  now = Date.now(),
): boolean {
  return Boolean(device?.lastSeenAt && (!device.license?.enforcementEnabled || device.license.status === 'active') &&
    now - new Date(device.lastSeenAt).getTime() < ACTIVE_CAMERA_WINDOW_MS);
}
